// takes the credit tiers array and returns the corresponding default rates for "New" and "Used" vehicle types
const getDefaultInterestRates = (tiers, type) => {
  const defaultRate = {};
  defaultRate[type.toLowerCase()] = tiers?.find(r => r.isDefault)?.aprs?.find(apr => apr.isDefault)?.rate ?? null;
  return defaultRate;
};

// takes the mileages array and returns the default mileage
const getLeaseMileageOptions = mileages => {
  const mileageOptions = mileages.map(m => m.mileage).sort((a, b) => a - b);
  return mileageOptions.length ? mileageOptions : null;
};

// takes the term options array and returns the default lease term
const getLeaseTermOptions = terms => {
  const termOptions = terms.map(t => t.months).sort((a, b) => a - b);
  return termOptions.length ? termOptions : null;
};

// takes the DR settings API response and returns lease and finance defaults
const getDefaults = function () {
  let criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let type = arguments.length > 1 ? arguments[1] : undefined;
  let hasLeasing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const {
    leasing,
    financing,
    creditTiers
  } = criteria || {};
  const defaultCreditTier = creditTiers?.creditTiers.find(t => t.isDefault) ?? null;
  const poorCreditDefaults = creditTiers?.creditTiers.find(t => t.name.toLowerCase() === 'poor') ?? null;
  const {
    name,
    aprs
  } = defaultCreditTier || {};
  const leasingDefaults = {};
  if (hasLeasing) {
    leasingDefaults.dealerSelectedLeaseTerm = leasing?.terms.find(t => t.isDefault)?.months ?? null;
    leasingDefaults.dealerSelectedLeaseMileage = leasing?.mileages.find(t => t.isDefault)?.mileage ?? null;
    leasingDefaults.dealerLeaseMileageOptions = getLeaseMileageOptions(leasing?.mileages) ?? null;
    leasingDefaults.dealerLeaseTermOptions = getLeaseTermOptions(leasing?.terms) ?? null;
  }
  const defaultLoanTerm = financing[`defaultTerm${type}`];
  const defaultCreditType = name ? name.replace(/\s/g, '').toLowerCase() : '';

  // Extract finance terms from default tier as integer array for fallback
  const defaultFinanceTerms = defaultCreditTier?.aprs ? Array.from(new Set(defaultCreditTier.aprs.map(apr => apr.term))).sort((a, b) => a - b) : null;
  return {
    defaultLoanTerm: defaultLoanTerm && defaultLoanTerm !== 0 ? defaultLoanTerm : aprs.find(apr => apr.isDefault)?.term ?? null,
    defaultCreditType,
    defaultInterestRates: getDefaultInterestRates(creditTiers?.creditTiers, type),
    defaultFinanceTermOptions: defaultFinanceTerms,
    ...leasingDefaults,
    creditLowScore: poorCreditDefaults?.lowScore
  };
};
export { getDefaults as default };
